import { useCallback } from 'react';
import { useHandleSaveForm } from '../../use-handle-save-form';
import { createSaveFormError } from './createSubmitErrors';
export const useSaveModifiedFormWithErrorFlag = () => {
  const {
    handleSaveForm: handleSaveFormWithErrorFlag
  } = useHandleSaveForm();
  return {
    saveModifiedFormWithErrorFlag: useCallback(async formStore => {
      if (formStore.answersModified) {
        try {
          await handleSaveFormWithErrorFlag();
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
          throw createSaveFormError(error);
        }
      }
    }, [handleSaveFormWithErrorFlag])
  };
};